import React, { useCallback, useEffect, useState } from 'react';
import itiFonctionnaliteService from '../../services/itiFonctionnaliteService';
import ItiReferentielAdminPanel, { emptyCategoryForm } from './ItiReferentielAdminPanel';
import useAppConfirm from '../../hooks/useAppConfirm';
import { notify } from '../common/AppToast';

const emptyOptionForm = { libelle: '', sort_order: 0 };

const ItiFonctionnalitesAdminSection = () => {
  const { ask, modal } = useAppConfirm();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [categoryForm, setCategoryForm] = useState(emptyCategoryForm);
  const [optionForms, setOptionForms] = useState({});
  const [showCategoryForm, setShowCategoryForm] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await itiFonctionnaliteService.getAdminTree();
      setCategories(data);
      setExpanded((prev) => {
        const next = { ...prev };
        data.forEach((cat) => {
          if (next[cat.id] === undefined) next[cat.id] = true;
        });
        return next;
      });
    } catch (err) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleCreateCategory = async (event) => {
    event.preventDefault();
    if (!categoryForm.libelle.trim()) return;

    setSaving(true);
    try {
      await itiFonctionnaliteService.createCategory({
        libelle: categoryForm.libelle.trim(),
        icone: categoryForm.icone.trim() || null,
        sort_order: Number(categoryForm.sort_order) || 0,
      });
      setCategoryForm(emptyCategoryForm);
      setShowCategoryForm(false);
      notify.success('Cat?gorie ajout?e');
      await load();
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleUpdateCategory = async (category, patch) => {
    setSaving(true);
    try {
      await itiFonctionnaliteService.updateCategory(category.id, patch);
      notify.success(patch.active === false ? 'Cat?gorie masqu?e' : patch.active === true ? 'Cat?gorie visible' : 'Cat?gorie mise ? jour');
      await load();
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteCategory = async (category) => {
    const ok = await ask({
      title: 'Supprimer cette cat�gorie ?',
      message: `Supprimer la cat�gorie ? ${category.libelle} ? et toutes ses options ?`,
      confirmLabel: 'Supprimer',
      confirmVariant: 'danger',
    });
    if (!ok) {
      return;
    }

    setSaving(true);
    try {
      await itiFonctionnaliteService.deleteCategory(category.id);
      notify.success('Cat?gorie supprim?e');
      await load();
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleCreateOption = async (event, categoryId) => {
    event.preventDefault();
    const form = optionForms[categoryId] ?? emptyOptionForm;
    if (!form.libelle.trim()) return;

    setSaving(true);
    try {
      await itiFonctionnaliteService.createOption({
        categorie_id: categoryId,
        libelle: form.libelle.trim(),
        sort_order: Number(form.sort_order) || 0,
      });
      setOptionForms((prev) => ({ ...prev, [categoryId]: emptyOptionForm }));
      notify.success('Fonctionnalit? ajout?e');
      await load();
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleUpdateOption = async (option, patch) => {
    setSaving(true);
    try {
      await itiFonctionnaliteService.updateOption(option.id, patch);
      notify.success(patch.active === false ? 'Fonctionnalit? masqu?e' : patch.active === true ? 'Fonctionnalit? visible' : 'Fonctionnalit? mise ? jour');
      await load();
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteOption = async (option) => {
    const ok = await ask({
      title: 'Supprimer cette fonctionnalite ?',
      message: `Supprimer � ${option.libelle} � ?`,
      confirmLabel: 'Supprimer',
      confirmVariant: 'danger',
    });
    if (!ok) {
      return;
    }

    setSaving(true);
    try {
      await itiFonctionnaliteService.deleteOption(option.id);
      notify.success('Fonctionnalit? supprim?e');
      await load();
    } catch (err) {
      notify.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
    <ItiReferentielAdminPanel
      addOptionLabel="Ajouter une fonctionnalit?"
      emptyOptionMessage="Aucune fonctionnalit? pour le moment. Utilisez le champ ci-dessus pour en ajouter une."
      optionCountSingular="fonctionnalit?"
      optionCountPlural="fonctionnalit?s"
      optionPlaceholder="Ex. E-commerce"
      categoryPlaceholder="Ex. Fonctionnalit?s du site"
      categories={categories}
      loading={loading}
      saving={saving}
      expanded={expanded}
      onToggleCategory={(id) => setExpanded((prev) => ({ ...prev, [id]: !prev[id] }))}
      showCategoryForm={showCategoryForm}
      onToggleCategoryForm={() => setShowCategoryForm((prev) => !prev)}
      categoryForm={categoryForm}
      onCategoryFormChange={setCategoryForm}
      onCreateCategory={handleCreateCategory}
      optionForms={optionForms}
      onOptionFormChange={(categoryId, form) => setOptionForms((prev) => ({ ...prev, [categoryId]: form }))}
      onCreateOption={handleCreateOption}
      onUpdateCategory={handleUpdateCategory}
      onDeleteCategory={handleDeleteCategory}
      onUpdateOption={handleUpdateOption}
      onDeleteOption={handleDeleteOption}
    />
    {modal}
    </>
  );
};

export default ItiFonctionnalitesAdminSection;
